import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "heart"
const HeartIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M20.25 9.122C20.25 6.755 18.394 4.875 16.154 4.875 14.676 4.875 13.37 5.688 12.648 6.927L12 8.035 11.352 6.927C10.63 5.688 9.324 4.875 7.846 4.875 5.606 4.875 3.75 6.755 3.75 9.122 3.75 10.27 4.135 11.181 4.365 11.655 4.63 12.199 4.947 12.68 5.225 13.063 5.785 13.832 6.46 14.575 7.035 15.168 7.627 15.782 8.21 16.33 8.637 16.722 8.854 16.92 9.035 17.081 9.164 17.196L9.32 17.332 9.338 17.348 9.365 17.371 9.383 17.387 9.41 17.409 9.41 17.41 12 19.635 14.588 17.412 14.591 17.41 14.617 17.387 14.635 17.371 14.662 17.348 14.681 17.332 14.836 17.196C14.966 17.08 15.146 16.919 15.362 16.72 15.789 16.33 16.372 15.781 16.966 15.168 17.54 14.576 18.216 13.833 18.775 13.064 19.053 12.68 19.37 12.199 19.635 11.655 19.865 11.181 20.25 10.269 20.25 9.122M8.897 17.958 8.864 17.99 8.405 18.524 8.41 18.527 8.897 17.96 8.905 17.95zM15.102 17.96 15.59 18.527Q15.593 18.527 15.595 18.524L15.137 17.99 15.103 17.958 15.095 17.95zM21.75 9.122C21.75 10.597 21.256 11.75 20.985 12.31 20.668 12.961 20.295 13.522 19.988 13.945 19.368 14.796 18.64 15.597 18.043 16.213 17.42 16.853 16.815 17.423 16.375 17.827 16.153 18.031 15.965 18.2 15.83 18.32L15.666 18.464 15.632 18.492 15.617 18.505 15.615 18.507 15.601 18.519 15.591 18.527V18.528L12 21.614 8.409 18.527 8.399 18.52 8.385 18.507 8.383 18.505 8.368 18.492 8.334 18.464 8.171 18.319C8.035 18.2 7.847 18.031 7.625 17.827 7.185 17.424 6.579 16.853 5.958 16.213 5.36 15.597 4.63 14.796 4.012 13.945 3.704 13.522 3.332 12.961 3.015 12.31 2.744 11.75 2.25 10.597 2.25 9.122 2.25 5.97 4.734 3.375 7.846 3.375 9.501 3.375 10.98 4.112 12 5.273 13.02 4.112 14.5 3.375 16.154 3.375 19.266 3.375 21.75 5.97 21.75 9.122" />
        </svg>
      }
    </span>
  )
}
export default HeartIcon
